import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import { Form, Label } from 'reactstrap';
import scrollToFirstError from 'lib/utils/scrollToFirstError'
import LinkFieldset from './fieldsets/LinkFieldset';
import FieldsArray from './FieldsArray';
import { stepValidationFactory } from 'actions/submissionFormActions';
import { DesktopMediaQuery } from '../MediaQueries';

class LinksForm extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    formErrors: PropTypes.object,
    isLoading: PropTypes.bool,
    urlTypes: PropTypes.array.isRequired,
    onSetAsPrimary: PropTypes.func.isRequired,
    pricingType: PropTypes.string.isRequired,
  }

  render() {
    const { handleSubmit, onSetAsPrimary, urlTypes, formErrors, pricingType } = this.props;

    let lockedType = null;
    if (pricingType === 'tickets_in_advance' || pricingType === 'registration_required') {
      lockedType = 'Tickets';
    }

    return (
      <Form onSubmit={handleSubmit}>
        <fieldset>
          <DesktopMediaQuery>
            <div className="row">
              <div className="col-3">
                <Label>URL Type <span className="text-danger">*</span></Label>
              </div>
              <div className="col-5">
                <Label>URL Address <span className="text-danger">*</span></Label>
              </div>
            </div>
          </DesktopMediaQuery>
          <FieldsArray
            name="links"
            component={LinkFieldset}
            componentProps={{ urlTypes, onSetAsPrimary, lockedType }}
            resourceName="link"
            formErrors={formErrors}
            btnVisible={false}
            rerenderOnEveryChange={true}
          />
        </fieldset>
        <button type="submit" className="d-none" />
      </Form>
    );
  }
}

export default reduxForm({
  form: 'eventSubmission',
  asyncValidate: stepValidationFactory('links'),
  destroyOnUnmount: false,
  onSubmitFail: scrollToFirstError,
  persistentSubmitErrors: true,
})(LinksForm);



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/LinksForm.jsx